import { Component, Input, SimpleChanges } from '@angular/core';
import { Report } from '../../../models/report.model';
import { PhotoService } from '../../../services/photo.service';

@Component({
  selector: 'app-cadastre-read-mode',
  templateUrl: './cadastre-read-mode.component.html',
  styleUrls: ['./cadastre-read-mode.component.scss'],
})
export class CadastreReadModeComponent {
  @Input() reportId!: string;
  @Input() cadastre!: Report.Cadastre;
  @Input() cityLabel!: string;
  @Input() cityCode!: string;

  cartographieBinary!: string | undefined;

  constructor(private readonly photoService: PhotoService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (
      changes['reportId']?.currentValue ||
      changes['cadastre']?.currentValue?.plotReference !==
        changes['cadastre']?.previousValue?.plotReference
    ) {
      // try catch
      try {
        this.cartographieBinary = await this.photoService.getPlotCartography(
          this.reportId,
        );
      } catch {
        this.cartographieBinary = undefined;
      }
    }
  }
}
